export default __webpack_public_path__ + "static/progaming-ico-ed5f7deffa365d60b7502c4f12638863.png";